import * as PIXI from 'pixi.js';
import gsap from 'gsap';

import { CARD_WIDTH } from '../utils/commonUtils';

import CardContainer from './cardContainer';

export default class CharacterAreaContainer extends PIXI.Container {
    constructor() {
        super();
    }

    updateCharacterArea(characterArea, clientGameState) {
        while (this.children.length > 0) {
            this.children[0].destroy();
        }

        const numberOfCharacters = characterArea.length;
        for (let i = 0; i < numberOfCharacters; i++) {
            const character = characterArea[i];
            const characterContainer = new CardContainer(character);

            const middleIndex = (numberOfCharacters - 1) / 2;
            const padding = 0.1;
            const offsetX = (i - middleIndex) * (CARD_WIDTH) * (1 + padding);

            characterContainer.x = offsetX;
            characterContainer.y = 0;
            characterContainer.scale.set(0.83);

            this.addChild(characterContainer);
        }

        this.children.forEach(child => {
            if (
                clientGameState.validBlockers?.includes(child.cardInstance.instanceId) ||
                clientGameState.selectableCards?.includes(child.cardInstance.instanceId) ||
                child.cardInstance.attachedDon.some(don => clientGameState?.selectableCards?.includes(don.instanceId))
            ) {
                if (clientGameState.selectedCard === child.cardInstance.instanceId) {
                    child.setHighlightSelected();
                } else {
                    child.setHighlightSelectable();
                }
            }

            const selectedDonsForReturn = child.cardInstance.attachedDon.filter(don => clientGameState?.donsSelectedForReturn?.includes(don.instanceId));
            if (selectedDonsForReturn.length) {
                child.setDonsForReturnCounter(selectedDonsForReturn.length);
            }

            if (clientGameState.validAttackTargets?.includes(child.cardInstance.instanceId)) {
                child.setHighlightAttackTarget();
            }
        });

        
    }

    unhighlightAllCards() {
        this.children.forEach(child => child.unhighlightCard());
    }

    hideSkulls() {
        this.children.forEach(child => child.hideSkull());
    }

    showSkulls(attackerPower, defenders) {
        this.children.forEach(child => {
            const childInstanceId = child.cardInstance.instanceId;
            if (defenders.includes(childInstanceId)) {
                if (attackerPower >= child.cardInstance.currentPower) {
                    child.showSkull();
                }
            }
        });
    }

    playPlayerPlayedCharacterAnimation(newNumOfCharacters) {
        const promises = [];
        for (let i = 0; i < this.children.length; i++) {
            const characterContainer = this.children[i];

            const middleIndex = (newNumOfCharacters - 1) / 2;
            const padding = 0.1;
            const offsetX = (i - middleIndex) * (CARD_WIDTH) * (1 + padding);

            promises.push(gsap.to(characterContainer, {
                duration: 0.5,
                pixi: {
                    x: offsetX,
                }
            }));
        }

        return Promise.all(promises);
    }
}
